/** @format */

/** 侧边栏所有 MenuItem 的 key，与 SiderBar 中定义保持一致 */
export const SIDEBAR_MENU_KEYS = [
  '/monitor/generalview/home',
  '/monitor/menu',
  '/monitor/prometheusmonitor/instanceList',
  '/monitor/prometheusmonitor/metricexplore',
  '/monitor/prometheusmonitor/alarm',
  '/monitor/grafana/instancelist',
  '/monitor/aiobservability/serviceoverview',
  '/monitor/aiobservability/sessionanalysis',
  '/monitor/aiobservability/traceanalysis',
  '/monitor/aiobservability/accesscenter',
  '/monitor/alarmServer/rule/home',
  '/monitor/alarmServer/history/home',
  '/monitor/alarmServer/alarming/home',
  '/monitor/alarmServer/template/home',
  '/monitor/alarmServer/silences/home',
  '/monitor/alarmServer/alertTarget',
  '/monitor/custom/metric',
  '/monitor/custom/alarm',
  '/monitor/eventops/trigger',
  '/monitor/eventops/scene',
  '/monitor/eventops/record',
  '/monitor/eventops/functions',
  '/monitor/systomcenter/home',
  '/monitor/dashboard/home',
  '/monitor/group/home'
] as const

type MenuKey = typeof SIDEBAR_MENU_KEYS[number]

/** 路由与菜单 key 无法通过前缀匹配时的显式映射 */
const ROUTE_MENU_ALIASES: Array<{ test: (pathname: string) => boolean; key: MenuKey }> = [
  {
    test: pathname =>
      pathname.includes('/monitor/list/') || pathname.startsWith('/monitor/detail/'),
    key: '/monitor/menu'
  },
  {
    test: pathname => pathname.startsWith('/monitor/aiobservability/servicedetail'),
    key: '/monitor/aiobservability/serviceoverview'
  },
  {
    test: pathname => pathname.startsWith('/monitor/eventops/approve/'),
    key: '/monitor/eventops/trigger'
  }
]

function normalizePathname(pathname: string): string {
  const path = pathname.replace(/\/$/, '')
  return path || '/'
}

/**
 * 判断当前路由是否归属某个菜单项：
 * 1. 完全相等
 * 2. 当前路由是菜单路径的子路径（详情页等）
 * 3. 菜单以 /home 结尾时，按上级路径段匹配（如 history/detail → history/home）
 */
function isMenuRouteMatch(menuKey: string, pathname: string): boolean {
  if (pathname === menuKey) {
    return true
  }
  if (pathname.startsWith(`${menuKey}/`)) {
    return true
  }

  const menuSegments = menuKey.split('/').filter(Boolean)
  const pathSegments = pathname.split('/').filter(Boolean)
  const lastSegment = menuSegments[menuSegments.length - 1]

  if (lastSegment === 'home' && menuSegments.length > 1) {
    const baseSegments = menuSegments.slice(0, -1)
    return (
      baseSegments.every((segment, index) => pathSegments[index] === segment) &&
      pathSegments.length > baseSegments.length
    )
  }

  return false
}

/** 根据当前路由自动解析应高亮的菜单项 key */
export function getSelectedMenuKey(
  pathname: string,
  menuKeys: readonly string[] = SIDEBAR_MENU_KEYS
): string | undefined {
  const path = normalizePathname(pathname)

  for (const alias of ROUTE_MENU_ALIASES) {
    if (alias.test(path)) {
      return alias.key
    }
  }

  const matchedKeys = menuKeys.filter(key => isMenuRouteMatch(key, path))
  if (!matchedKeys.length) {
    return undefined
  }

  return matchedKeys.sort((a, b) => b.length - a.length)[0]
}
